import React, { Component } from "react";
import "./App.css";
import Alert from "react-bootstrap/Alert";
import { Route, Switch } from "react-router-dom";
import NavBar from "./Components/NavBar/NavBar";
import Intro from "./Containers/Intro/Intro";
import About from "./View/About-us/AboutUs";
import Contact from "./View/Conatct-us/Contact";
import Catalogue from "./View/Catalogue/Catalogue";
import bookDetail from "./Components/BookDetail/BookDetail";
import Cart from "./View/Cart/Cart";
import Shipping from "./View/ShippingAddress/ShippingAddress";
import OrderSummmary from "./Containers/OrderSummary/OrderSummary";
import Confirmation from "./Components/Confirmation/Confimation";
import Resources from "./Containers/Resources/Resources";
import Publish from "./Containers/PublishWithUs/PublishWithUs";
import Error from "./Containers/Error/Error";
import Samplecopy from "./Containers/SampleCopy/SampleCopy";
import Privacy from "./Containers/Privacy/Privacy";
import FAQ from "./Containers/FAQ/FAQ";
import { connect } from "react-redux";
import ProtectedRoutes from "./HOC/ProtectedRoutes/ProtectedRoutes";

class App extends Component {
  render() {
    return (
      <div className="App">
       
        <NavBar />
        <Switch>
          <Route path="/" exact component={Intro} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Route exact path="/catalogue" component={Catalogue} />
          <Route exact path="/resources" component={Resources} />
          <Route path="/catalogue/:id/:bookname" component={bookDetail} />
          <Route exact path="/cart" component={Cart} />
          <Route path="/404" component={Error} />
          <Route path="/orderplaced" component={Confirmation} />
          <Route path="/publishwithus" component={Publish} />
          <Route path="/samplecopy" component={Samplecopy} />
          <Route path="/privacy" component={Privacy} />
          <Route path="/faq" component={FAQ} />
          {/* <ProtectedRoutes
            path="/orderplaced"
            component={Confirmation}
            cartItem={this.props.orderConfirmed}
          /> */}
          <ProtectedRoutes
            exact
            path="/cart/shipping"
            component={Shipping}
            cartItem={this.props.addedBook}
          />
          <ProtectedRoutes
            path="/cart/shipping/ordersummary"
            component={OrderSummmary}
            cartItem={this.props.addedBook}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    itemAdded: state.book.itemAdded,
    addedBook: state.book.addedBooks,
    orderConfirmed: state.book.orderConfirmed,
  };
};

export default connect(mapStateToProps, null)(App);
